import React, { useState, useEffect } from 'react';
import { MdCookie } from 'react-icons/md';
import { getConsent, setConsent, loadAnalyticsScripts } from '../../utils/cookieConsent';

function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    setConsent('all');
    loadAnalyticsScripts();
    setVisible(false);
  };

  const handleNecessaryOnly = () => {
    setConsent('necessary');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className='fixed bottom-0 left-0 w-full z-[9998]'
      style={{
        animation: 'slideUp 0.4s ease-out',
        backgroundColor: '#0d2d47',
        borderTop: '1px solid #1e4d6b',
      }}
    >
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }
      `}</style>

      <div className='max-w-5xl mx-auto px-6 py-4 flex items-center justify-between gap-6 h-sm:flex-col h-sm:items-start'>

        {/* Texto */}
        <div className='flex items-start gap-3 flex-1'>
          <MdCookie className='text-orange-400 text-2xl flex-shrink-0 mt-0.5' />
          <p className='text-gray-300 text-sm leading-relaxed'>
            <span className='font-semibold text-white'>Utilizamos cookies</span> e tecnologias similares para
            melhorar sua experiência, analisar o tráfego e apoiar nossas ações de marketing.
            Os cookies essenciais são necessários para o funcionamento do site e não podem ser recusados.{' '}
            <a href='/politica-privacidade' className='underline hover:text-white transition-colors duration-200' style={{ color: '#f5be88' }}>
              Saiba mais
            </a>.
          </p>
        </div>

        {/* Botões */}
        <div className='flex gap-3 flex-shrink-0 h-sm:w-full h-sm:flex-col'>
          <button
            type='button'
            onClick={handleNecessaryOnly}
            className='px-5 py-2 rounded-lg text-sm font-medium border text-gray-300 hover:border-white hover:text-white transition-colors duration-200 h-sm:w-full'
            style={{ borderColor: '#4a7a9b' }}
          >
            Apenas necessários
          </button>
          <button
            type='button'
            onClick={handleAcceptAll}
            className='px-5 py-2 rounded-lg text-sm font-semibold text-white transition-opacity duration-200 hover:opacity-80 h-sm:w-full'
            style={{ backgroundColor: '#c76f36' }}
          >
            Aceitar todos
          </button>
        </div>

      </div>
    </div>
  );
}

export default CookieBanner;
